import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import NumbersIcon from '@mui/icons-material/Numbers';
import CustomDataGrid from '../../../../components/ui/customDataGrid/customDataGrid.component';
import { NUMERATION_SCHEMA_ENDPOINT } from '../../../../consts';
import styles from './tenantNumerationSchemasList.module.css';
import { useHasPermission } from '../../../../contexts/auth';
import { TENANT_ROUTES } from '../../tenantConfig.routes';
import {
  containsStringFilterOperators,
  equalsNumberFilterOperators,
} from '../../../../components/ui/customDataGrid/filterOperators';

export const TenantNumerationSchemasList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewSchemas = useHasPermission("settlement.view_numerationschema");

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      filterOperators: equalsNumberFilterOperators(),
    },
    {
      field: 'name',
      headerName: t('Name'),
      filterOperators: containsStringFilterOperators(),
    },
    {
      field: 'template',
      headerName: t('Template'),
      filterOperators: containsStringFilterOperators(),
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(TENANT_ROUTES.numerationSchema(id));
  };

  if (!canViewSchemas) {
    return null;
  }

  return (
    <Box className={styles.container}>
      <CustomDataGrid
        icon={<NumbersIcon />}
        title={t('Numeration Schemas')}
        url={NUMERATION_SCHEMA_ENDPOINT}
        gridSettingsKey="TENANT_NUMERATION_SCHEMAS"
        columns={columns}
        refreshEventName="numerationSchemasUpdated"
        onRowClick={handleRowClick}
      />
    </Box>
  );
};
